import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const ProviderGamesContainer = styled.div<{
  cols: string;
  children: React.ReactNode;
}>`
  transform: translateY(${({ cols }) => (cols === '1' ? rem(-8) : rem(-20))});
  display: grid;
  grid-template-columns: ${({ cols }) =>
    Array.from({ length: Number(cols) || 3 }, () => '1fr').join(' ')};
  grid-gap: ${rem(4)};
`;

export default ProviderGamesContainer;
